import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface BlogSearchBarProps {
  variant?: "hero" | "inline";
  defaultValue?: string;
  placeholder?: string;
  autoFocus?: boolean;
}

export default function BlogSearchBar({
  variant = "inline",
  defaultValue = "",
  placeholder = "Ex.: Como criar um site, o que é DNS, como configurar SSL...",
  autoFocus = false,
}: BlogSearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const term = value.trim();
    if (!term) return;
    navigate(`/blog/busca?q=${encodeURIComponent(term)}`);
  };

  const hero = variant === "hero";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={
        hero
          ? "flex w-full flex-col gap-2 rounded-xl border border-background-200 bg-background-50 p-2 sm:flex-row sm:items-center"
          : "flex w-full items-center gap-2 rounded-lg border border-background-200 bg-background-50 p-1.5"
      }
    >
      <span
        className={`flex items-center justify-center pl-3 text-foreground-400 ${
          hero ? "h-11 w-11" : "h-9 w-9"
        }`}
      >
        <i className={`${hero ? "ri-search-2-line text-xl" : "ri-search-line text-lg"}`} aria-hidden="true"></i>
      </span>
      <input
        type="search"
        name="q"
        value={value}
        autoFocus={autoFocus}
        onChange={(event) => setValue(event.target.value)}
        placeholder={hero ? "O que você quer aprender?" : placeholder}
        aria-label="Pesquisar no blog"
        className={`min-w-0 flex-1 bg-transparent text-foreground-900 outline-none placeholder:text-foreground-400 ${
          hero ? "py-3 text-base" : "py-2 text-sm"
        }`}
      />
      <button
        type="submit"
        className={`inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 font-semibold text-background-50 transition-colors hover:bg-primary-600 ${
          hero ? "px-6 py-3 text-sm" : "px-4 py-2 text-xs"
        }`}
      >
        <i className="ri-search-line" aria-hidden="true"></i>
        Pesquisar
      </button>
    </form>
  );
}